<template>
    <adam v-if="company" :company="company"></adam>
</template>

<script>
    import Adam from '@/components/Adam'

    export default {
        components: {
            Adam
        },
        computed: {
            user() {
                return this.$store.getters.getUser;
            },
            company() {
                if (this.$route.params.company) {
                    return this.$route.params.company;
                } else if (this.user) {
                    return this.user.company_id.toString();
                } else {
                    return null;
                }
            }
        }
    }
</script>